export default __webpack_public_path__ + "static/wix-cc97be3b8a0d32f870158125543c79e0.svg";